import { Alert, Button, Space } from 'antd';
import { WalletOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import {
    clearPackageEntitlement,
    getPackageDocType,
    isAmountEntitlement,
    useSelectedPackageEntitlement,
} from '../../Service/packageEntitlements';

export default function PackageSelection() {
    const selected = useSelectedPackageEntitlement();
    const { pathname } = useLocation();
    if (!selected || !['/', '/reduce', '/search/ppt'].includes(pathname)) return null;
    const isCoupon = Number(selected.codeType) === 1;
    const isAmount = isAmountEntitlement(selected);
    const isReduce = pathname === '/reduce';
    const reductionMismatch =
        isReduce &&
        !isAmount &&
        (isCoupon || getPackageDocType(selected) !== 'THESIS_MODIFICATION');
    const description = reductionMismatch
        ? '当前权益不能直接用于独立降重。文章套餐附带的降重服务，请在文章生成时选择；优惠券请在文章支付页面使用。'
        : isAmount
          ? '普通金额码可用于当前内容，请在支付页面确认兑换。保留当前已选服务，提交时核验订单金额是否在额度内；一次使用，不保留余额。'
          : isReduce
            ? '请在降重支付页面输入已有凭证并核对适用范围，确认使用后开始处理。'
            : isCoupon
              ? '完成文章题目和大纲后，在支付页面点击“确认使用优惠券”查看抵扣规则。优惠券用于抵扣符合条件的订单费用，不能直接兑换全文。'
              : '继续填写内容和编辑大纲，最后点击“使用已购套餐”。确认生成前不会消耗套餐。';
    return (
        <div style={{ width: 'min(1120px, calc(100% - 32px))', margin: '16px auto 0' }}>
            <Alert
                showIcon
                type={reductionMismatch ? 'warning' : 'info'}
                icon={reductionMismatch ? undefined : <WalletOutlined style={{ color: 'var(--ant-color-primary, #a277ee)' }} />}
                style={reductionMismatch ? undefined : { background: 'var(--ant-color-primary-bg, #f7f2ff)', borderColor: 'var(--ant-color-primary-border, #e3d8ff)' }}
                message={`已选择：${selected.redeemName}`}
                description={description}
                action={
                    <Space>
                        <Button size="small" onClick={clearPackageEntitlement}>
                            取消选择
                        </Button>
                    </Space>
                }
            />
        </div>
    );
}
